export default __webpack_public_path__ + "static/media/product-image-hover-20.64281d02.jpg";